import { createContext, useContext } from 'react';

import { SearchResultCardView } from '../types/types';

export type VendorGirdCardsValues = {
  vendorOrQuizCardViews: SearchResultCardView[];
};

export const VendorGridCardsContext = createContext<VendorGirdCardsValues>({
  vendorOrQuizCardViews: [],
});

/**
 * Provides the cards to use in the vendor grid: either vendor cards OR quiz cards
 */
export const useVendorGridCards = () => useContext(VendorGridCardsContext);
